/** 북마크(링크 카드/임베드) 기능 슬라이스 — 블록 직렬화만 등록.
 * 생성은 링크 툴바의 "카드/임베드 전환"(editor.js) 경로이며, 붙여넣기는 기본 인라인 링크 정책 유지. */
import { bookmarkBlockToElement, bookmarkElementToBlock } from "./bookmark.js";
import { attachBookmarkControls } from "./controls.js";

export default {
  name: "bookmark",
  blocks: { bookmark: { toElement: bookmarkBlockToElement, fromElement: bookmarkElementToBlock } },
  controls: (editorEl, ctx) => attachBookmarkControls(editorEl, ctx),
};
